import { MonedaEntity } from "../../../../../infraestructure/persistence/rest/MonedasAdapter"

export const createOptions = (data:any) =>{
  return data.map((m: MonedaEntity)=> { return { label: m.name, value: m.iso } })
}